import React__default from 'react';
import { AutoshipmentLogoLockup } from '@zooplus/ui-components';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const AutoshipLogo = (props) => {
    const { site, locale } = useSiteContext();
    return (React__default.createElement("div", { className: props.className },
        React__default.createElement(AutoshipmentLogoLockup, { size: props.logoSize, locale: locale, realm: site.realm })));
};

export { AutoshipLogo };
//# sourceMappingURL=AutoshipLogo.js.map
